import { render, staticRenderFns } from "./createGroupModalPages.vue?vue&type=template&id=023d4026&scoped=true&"
import script from "./createGroupModalPages.vue?vue&type=script&lang=js&"
export * from "./createGroupModalPages.vue?vue&type=script&lang=js&"
import style0 from "./createGroupModalPages.vue?vue&type=style&index=0&id=023d4026&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023d4026",
  null
  
)

export default component.exports